import React from "react";

const SingUpWihGoggle = () => {
  return (
    <div>
      <div
        className="w-full px-3 py-2 placeholder-gray-300 border border-gray-300 focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300 dark:bg-gray-700 dark:text-white dark:placeholder-gray-500 dark:border-gray-600 dark:focus:ring-gray-900 dark:focus:border-gray-500
                text-center rounded-3xl bg-gray-100 flex items-center justify-center cursor-pointer"
      >
        <img src="Images/GOOG.svg" alt="" className="w-4 mx-2" />
        <span className="font-bold capitalize"> Sign Up with Goggle</span>
      </div>
    </div>
  );
};

export default SingUpWihGoggle;
